import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Upload from "@/components/UpLoadFile/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, ref, toRaw } from "vue";
import { useRoute } from "vue-router";
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { saveAs } from "@/hooks/downUrl";
import { changeInfoTotal } from "@/hooks/changeInfoTotal";
import { useStore } from "vuex";
export default defineComponent({
  components: {
    Head: Head,
    Upload: Upload
  },
  setup: function setup() {
    var route = useRoute();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var _route$query = route.query,
        id = _route$query.id,
        state = _route$query.state; // 提交按钮文字

    var submitText = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$btnText.$btn_submit;
    var store = useStore();
    var couruser = store.state.user.user.userId; // 是否可以审核

    var isAudit = ref(true); // 详情信息

    var detail = reactive({
      heartId: 0,
      title: "",
      activeUser: "",
      activeOrg: "",
      activeDuty: "",
      attachmentId: "",
      passiveUser: "",
      passiveOrg: "",
      passiveDuty: "",
      address: "",
      type: "",
      kind: "",
      createUser: "",
      note: "",
      content: "",
      files: [{
        name: '',
        id: ''
      }],
      talkTime: ''
    }); // 详情回显

    function getDetail() {
      return _getDetail.apply(this, arguments);
    } // 附件


    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getTalkDetail"](id);

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                Object.assign(detail, data);
                isAudit.value = state == '0' || data.heartStatus == '0' || data.heartStatus == '1'; // 附件回显

                if (detail.attachmentId != "") {
                  getUploadInfo(detail.attachmentId);
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getDetail.apply(this, arguments);
    }

    var uploadRef = ref(null);
    var files = []; //files不需要响应式，因为不需要渲染dom
    // 附件回显

    function getUploadInfo(_x) {
      return _getUploadInfo.apply(this, arguments);
    }

    function _getUploadInfo() {
      _getUploadInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ids) {
        var _uploadRef$value;

        var _yield$globalProperti2, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                files = [];
                _context2.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getUploadInfo"]({
                  ids: ids
                });

              case 3:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                data.forEach(function (item) {
                  files.push({
                    name: item.realName,
                    id: item.attachmentId
                  });
                  detail.files.push({
                    name: item.realName,
                    id: item.attachmentId
                  });
                });
                detail.files.splice(0, 1);
                (_uploadRef$value = uploadRef.value) === null || _uploadRef$value === void 0 ? void 0 : _uploadRef$value['editFile'](files);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getUploadInfo.apply(this, arguments);
    }

    onMounted(function () {
      // 详情
      getDetail();
    }); // 文件变动回调

    function filechange(_x2) {
      return _filechange.apply(this, arguments);
    } //下载


    function _filechange() {
      _filechange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(fileList) {
        var list, _yield$globalProperti3, code;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                list = toRaw(fileList);
                list.forEach(function (element) {
                  element.state = true;
                });
                detail.attachmentId = list.map(function (item) {
                  return item.id;
                }).join(',');
                _context3.next = 5;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["uploadTalkAnnex"]({
                  attachmentId: detail.attachmentId,
                  heartId: detail.heartId
                });

              case 5:
                _yield$globalProperti3 = _context3.sent;
                code = _yield$globalProperti3.code;

                if (code == 0) {
                  ElMessage({
                    type: 'success',
                    message: globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_success
                  });
                  changeInfoTotal(detail.heartId, "\u601D\u60F3\u6478\u6392(\u4E0A\u4F20\u9644\u4EF6):".concat(detail.title), 20);
                  getDetail();
                } else {
                  ElMessage({
                    type: 'success',
                    message: globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_error
                  });
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _filechange.apply(this, arguments);
    }

    function downUrl(id) {
      if (id) {
        saveAs(id);
      } else {
        ElMessage.error("资源已失效");
      }
    } // 审核


    var radio = ref(0);

    function handleAudit(_x3) {
      return _handleAudit.apply(this, arguments);
    }

    function _handleAudit() {
      _handleAudit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(s) {
        var myDate, newe, heartStatus, _yield$globalProperti4, code;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                myDate = new Date(detail.talkTime);
                newe = new Date().getTime();

                if (!(myDate.getTime() > newe)) {
                  _context4.next = 6;
                  break;
                }

                ElMessage.error("谈话未开始");
                _context4.next = 16;
                break;

              case 6:
                if (!(s != '2')) {
                  _context4.next = 10;
                  break;
                }

                ElMessage.error("谈话对象未上传附件");
                _context4.next = 16;
                break;

              case 10:
                // 提交审核
                // console.log(detail.heartId);
                heartStatus = radio.value;
                _context4.next = 13;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["turnAudit"]({
                  heartStatus: heartStatus,
                  heartId: detail.heartId
                });

              case 13:
                _yield$globalProperti4 = _context4.sent;
                code = _yield$globalProperti4.code;

                if (code == 0) {
                  getDetail();
                  ElMessage({
                    type: 'success',
                    message: globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_success
                  });
                  changeInfoTotal(detail.heartId, "\u601D\u60F3\u6478\u6392(\u5BA1\u6279):".concat(detail.title), 20);
                } else {
                  ElMessage({
                    type: 'info',
                    message: globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_error
                  });
                }

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _handleAudit.apply(this, arguments);
    }

    return {
      isAudit: isAudit,
      submitText: submitText,
      detail: detail,
      state: state,
      filechange: filechange,
      downUrl: downUrl,
      radio: radio,
      handleAudit: handleAudit,
      uploadRef: uploadRef,
      couruser: couruser
    };
  }
});